import React from 'react'

export default class extends React.Component{

  constructor(props)
  {
    super(props);
    this.state = {

    }
  }

  render()
  {
    return (
        <input
            type={`text`}
            value={this.props.value}
            onChange={(e) => {this.props.onChange && this.props.onChange(e)}}
        />
    )
  }
}